export default (text) => {
  return text
    .normalize("NFKC")
    .replace(/[^a-zA-Zà-üÀ-Ü\s]+/g, "")
    .replace(/\s+/g, " ")
    .trim()
};

